import { Accordion, Container, Row } from "react-bootstrap";

import './servicios.scss';
import { PrismicText, PrismicRichText } from "@prismicio/react";

const ServiciosIndex = ({ slice }) => {

  return (
    <main className="serviciosIndex" id="serviciosIndex">
      <Container>
        <Row>
          <section className="contenedorServicios col-12 col-md-11 col-lg-12">
            <h3><PrismicText field={slice.primary.title} /></h3>
            <PrismicRichText field={slice.primary.description} />
            <Accordion className="contenedorServicios col-12 col-md-11 col-lg-12">
              {slice.items.map(({ title_service, category, description_service, icon, index }) => (
                <Accordion.Item eventKey={title_service[0].text} key={title_service[0].text} className="servicio col-12 col-sm-11">
                  <Accordion.Header className="headerServicio">
                    <img src={icon.url} alt="icon" className="iconServicio" />
                    <div className="divHeader">
                      <h5 className="txtServicio"><PrismicText field={category} /></h5>
                      <h4 className="tituloServicio">
                        <PrismicText field={title_service} />
                      </h4>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body className="bodyServicio">
                    <PrismicRichText
                      field={description_service}
                      components={{
                        paragraph: ({ children }) => <p className="textoServicio">{children}</p>
                      }}
                    />
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </section>
        </Row>
      </Container>
    </main>
  );
};

export default ServiciosIndex;
